// extracted by mini-css-extract-plugin
export default {"link":"b1B_52","list":"c1B_52","item":"d1B_52","loading":"e1B_52","error":"f1B_52"};